/**
 * Resizes a video within an iframe container
 * @param {HTMLElement} iframeContainer - The container element that holds the iframe.
 * @param {HTMLIFrameElement} iframe - The video iframe element.
 * @param {Object} originalDimensions - The original width and height of the video.
 * @returns {Promise<void>} A Promise that resolves when the video resizing is complete.
 */
export function resizeVideo(iframeContainer, iframe, originalDimensions): Promise<void> {
	return new Promise((resolve) => {
		iframeContainer.classList.add('plyr--resize', 'plyr--resizing');

		if (iframe && iframe instanceof HTMLIFrameElement) {
			iframe.removeAttribute('style');

			if (!originalDimensions) {
				originalDimensions = {
					width: iframe.offsetWidth,
					height: iframe.offsetHeight,
				};
			}

			const containerWidth = iframeContainer.offsetWidth + 5;
			const containerHeight = iframeContainer.offsetHeight + 5;
			const oRatio = originalDimensions.width / originalDimensions.height;
			const cRatio = containerWidth / containerHeight;

			if (oRatio <= cRatio) {
				iframe.style.width = `${containerWidth}px`;
				iframe.style.height = `${containerWidth / oRatio}px`;
			} else {
				iframe.style.width = `${containerHeight * oRatio}px`;
				iframe.style.height = `${containerHeight}px`;
			}

			iframeContainer.classList.remove('plyr--resizing');
			resolve();
		}
	});
}

/**
 * Handles Play on Play button tap (mobile devices only)
 * @param {Plyr} plyr - The Plyr instance.
 * @returns {function} - Function to handle tap event.
 */
export const handleMobilePlayButton = (plyr) => (event) => {
	const isPlayButtonClicked = event.target.localName === 'button';

	if (plyr.touch && !plyr.playing && isPlayButtonClicked) {
		plyr.play();
	} else if (plyr.touch && plyr.playing && !isPlayButtonClicked) {
		plyr.pause();
	}
};
